module.exports = __webpack_public_path__ + "static/media/telemedEmergency.234529fb.svg";